import React from "react";

import { Card, GridLegacy } from "@mui/material";

import CardBody from "../../../../components/Card/CardBody";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Gastrofix() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormSwitchTC
              name={"apiaccounts__useTest"}
              tDefault={"Gebruik test omgeving"}
              tKey={"vestigingen.form.apiaccounts.label.useTest"}
            />
            <FormTextTC
              name={"apiaccounts__gastrofixBusinessId"}
              tDefault={"Business id"}
              tKey={"vestigingen.form.lightspeedk.label.gastrofixBusinessId"}
            />
            <FormTextTC
              name={"apiaccounts__gastrofixOperatorId"}
              tDefault={"Operator ID"}
              tKey={"vestigingen.form.lightspeedk.label.gastrofixOperatorId"}
            />
            <FormTextTC
              name={"apiaccounts__gastrofixToken"}
              tDefault={"Token"}
              tKey={"vestigingen.form.lightspeedk.label.gastrofixToken"}
            />
            <FormTextTC
              name={"apiaccounts__gastrofixWaiterId"}
              tDefault={"Medewerker id"}
              tKey={"vestigingen.form.lightspeedk.label.gastrofixWaiterId"}
            />
            <FormTextTC
              name={"apiaccounts__gastrofixPaymentId"}
              tDefault={"Payment id"}
              tKey={"vestigingen.form.lightspeedk.label.gastrofixPaymentId"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Gastrofix;
